import React from 'react'
import { Route } from 'react-router-dom'

import CadastrosMenu from './CadastrosMenu/CadastrosMenu'
import Cliente from './Cliente/Cliente'
import Produto from './Produto/Produto'
import Motorista from './Motorista/Motorista'
import { auth } from '../../../services/util/auth.service'
import Veiculo from './Veiculo/Veiculo'
import RotasEntrega from './RotasEntrega/RotasEntrega'
import GrupoProdutos from './GrupoProdutos/GrupoProdutos'
import ListaEnvioEmail from './ListaEnvioEmail/ListaEnvioEmail'
import Emails from './ListaEnvioEmail/Emails/Emails'
import LeadTimeRecebimentoCarga from './LeadTimeRecebimentoCarga/LeadTimeRecebimentoCarga'
import Transportadora from './Transportadora/Transportadora'
import VeiculoTransferencia from './VeiculoTransferencia/VeiculoTransferencia'
import MotivoAtraso from './MotivoAtraso/MotivoAtraso'
import TipoVeiculo from '../Sistema/TipoVeiculo/TipoVeiculo'
import Seguradora from './Seguradora/Seguradora'
import Empresa from './Empresa/Empresa'
import RegrasFrete from './RegrasFrete/RegrasFrete'
import GestaoUsuarios from './GestaoUsuarios/GestaoUsuarios'
import Ajudante from './Ajudante/Ajudante'
import AnalistaMonitoramentoEntregas from './AnalistaMonitoramentoEntregas/AnalistaMonitoramentoEntregas'
import OcorrenciaEntrega from './OcorrenciaEntrega/OcorrenciaEntrega'
import ZonaEntrega from './ZonaEntrega/ZonaEntrega'

export default function Cadastros() {
  return (
    <React.Fragment>
      <Route path="/main/cadastros/menu" render={() => auth(<CadastrosMenu />)} />
      <Route path="/main/cadastros/clientes" render={() => auth(<Cliente />, 61)} />
      <Route path="/main/cadastros/produtos" render={() => auth(<Produto />, 62)} />
      <Route path="/main/cadastros/grupo-produtos" render={() => auth(<GrupoProdutos />, 63)} />
      <Route path="/main/cadastros/motoristas" render={() => auth(<Motorista />, 64)} />
      <Route path="/main/cadastros/veiculos" render={() => auth(<Veiculo />, 65)} />
      <Route path="/main/cadastros/rotas-entrega" render={() => auth(<RotasEntrega />, 66)} />
      <Route
        path="/main/cadastros/lista-envio-email"
        render={() => auth(<ListaEnvioEmail />, 67)}
      />
      <Route path="/main/cadastros/email" render={() => auth(<Emails />, 67)} />
      <Route
        path="/main/cadastros/lead-time-recebimento-carga"
        render={() => auth(<LeadTimeRecebimentoCarga />, 68)}
      />
      <Route path="/main/cadastros/transportadoras" render={() => auth(<Transportadora />, 28)} />
      <Route
        path="/main/cadastros/veiculo-transferencia"
        render={() => auth(<VeiculoTransferencia />, 69)}
      />
      <Route path="/main/cadastros/motivo-atraso" render={() => auth(<MotivoAtraso />, 31)} />
      <Route path="/main/cadastros/seguradoras" render={() => auth(<Seguradora />, 72)} />
      <Route path="/main/cadastros/tipo-veiculo" render={() => auth(<TipoVeiculo />, 70)} />
      <Route path="/main/cadastros/empresa" render={() => auth(<Empresa />, 71)} />
      <Route path="/main/cadastros/regras-frete" render={() => auth(<RegrasFrete />, 73)} />
      <Route path="/main/cadastros/gestao-usuarios" render={() => auth(<GestaoUsuarios />, 45)} />
      <Route path="/main/cadastros/ajudantes" render={() => auth(<Ajudante />, 74)} />
      <Route
        path="/main/cadastros/analista-monitoramento-entregas"
        render={() => auth(<AnalistaMonitoramentoEntregas />, 138)}
      />
      <Route path="/main/cadastros/zona-entregas" render={() => auth(<ZonaEntrega />, 147)} />
      <Route
        path="/main/cadastros/ocorrencia-entrega"
        render={() => auth(<OcorrenciaEntrega />, 148)}
      />
    </React.Fragment>
  )
}
